import React from "react"
import g from "glamorous"
import breakpoints from "../components/breakpoints.jsx"
import ProductList from "../components/product-list.jsx"

const Title = g.h2({
  textAlign: 'center',
  fontSize: `1em`,
  textTransform: `uppercase`,
  [breakpoints.TabletUp]: {
    textAlign: 'left',
    position: 'absolute',
    top: '0',
    left: '0',
    minWidth: `10em`,
  }
})
const ContentContainer = g.div({
  [breakpoints.TabletUp]: {
    position: 'relative',
    paddingLeft: `10em`,
    paddingRight: `10em`,
    paddingBottom: `2em`
  }
})
const Aside = g.aside({
    borderTop: `2px solid black`,
    paddingTop: `1em`
})

export default ({data}) => {
 const post = data.contentfulPage
  return(
    <div>
      <article>
        <ContentContainer>
          <Title>{post.title ? post.title : null}</Title>
          {post.content !== null ? <div dangerouslySetInnerHTML={{__html: post.content.childMarkdownRemark.html}}></div> : null}
        </ContentContainer>
      </article>
      <Aside>
        <ProductList products={ data.allContentfulWork }></ProductList>
      </Aside>
    </div>
  ) 
}

export const query = graphql`
    query pageQuery($id: String!) {
        contentfulPage(id: { eq: $id }) {
            id
            title
            content {
                childMarkdownRemark {
                    html
                }
            }
        },
        allContentfulWork(limit: 1000, sort: {fields: [releasedDate], order: DESC}) {
            totalCount
            edges {
                node {
                    id
                    title
                    releasedDate
                    photos {
                        description
                        file {
                            url
                        }
                    }
                    fields {
                        slug
                    }
                }
            }
        }
    }
`


// WEBPACK FOOTER //
// ./src/templates/page.js